import {
	createInteractionMetric,
	COMMENTS_SUMMARY_COMPONENT_INTERACTION,
} from '@confluence/browser-metrics';

export const COMMENTS_SUMMARY_INTERACTION_METRIC = createInteractionMetric({
	key: COMMENTS_SUMMARY_COMPONENT_INTERACTION,
});
